angular.module("app").directive("natureModalDetail", () => {
  let link = (scope) => {
    scope.allData = {
      data: scope.logodata,
      index: scope.index,
    };

    scope.data = scope.logodata[scope.index];

    scope.LeftButtonHandler = () => {
      let index = scope.allData.index;
      if (index > 0) {
        index--;
      }
      scope.allData.index = index;
      scope.data = scope.allData.data[index];
    };

    scope.RightButtonHandler = () => {
      try {
        let index = scope.allData.index;
        if (index < scope.allData.data.length - 1) {
          index++;
        }
        scope.allData.index = index;
        scope.data = scope.allData.data[index];
      } catch (e) {}
    };

    scope.closeClickHandler = () => {
      scope.closefunction();
    };

    scope.newmoodboard = (data) => {
      data.type = 'nature';
      scope.$emit("mood_state", data);
    };

    scope.shareFacebook = (url) => {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
    };

    scope.shareTwitter = (url) => {
      window.open("https://twitter.com/home?status=" + url);
    };

    scope.sharePinterest = (url) => {
      window.open("https://pinterest.com/pin/create/button/?url=" + url);
    };

    scope.shareGooglePlus = (url) => {
      window.open("https://plus.google.com/share?url=" + url);
    };

    scope.shareInstagram = (url) => {
      window.open("https://instagram.com/?url=" + url);
    };

    scope.isFlowerNatureMode = () => {
      return scope.natureMode.title === "flowers";
    };

    scope.isBirdNatureMode = () => {
      return scope.natureMode.title === "birds";
    };

    scope.isButterflyNatureMode = () => {
      return scope.natureMode.title === "butterflies";
    };

    scope.isEarthNatureMode = () => {
      return scope.natureMode.title === "earth";
    };
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbNatureContent/dbNatureModalView.html",
    link: link,
    scope: {
      logodata: "=",
      index: "=",
      onClose: "&",
      closefunction: "=",
      selectedItem: "=",
      natureMode: "=",
    },
  };
});
